export default {
  reports: 'Reports',
  components: 'Components',
};
